import type {
  ApiErrorResponse,
  LeaderboardResponse,
  SubmitResponse,
} from "../shared/types";

export class ApiError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(response: ApiErrorResponse, status: number) {
    super(response.message);
    this.name = "ApiError";
    this.code = response.code;
    this.status = status;
  }
}

async function readResponse<T>(response: Response): Promise<T> {
  const data: unknown = await response.json();
  if (!response.ok) {
    const fallback: ApiErrorResponse = {
      code: "REQUEST_FAILED",
      message: "网络开小差了，请稍后重试",
    };
    throw new ApiError(
      data && typeof data === "object"
        ? ({ ...fallback, ...(data as Partial<ApiErrorResponse>) } as ApiErrorResponse)
        : fallback,
      response.status,
    );
  }
  return data as T;
}

export async function getLeaderboard(): Promise<LeaderboardResponse> {
  const response = await fetch("/api/leaderboard", {
    headers: { Accept: "application/json" },
    cache: "no-store",
  });
  return readResponse<LeaderboardResponse>(response);
}

export async function submitAnswers(
  nickname: string,
  answers: readonly number[],
): Promise<SubmitResponse> {
  const response = await fetch("/api/submit", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ nickname, answers }),
  });
  return readResponse<SubmitResponse>(response);
}
